import { render, staticRenderFns } from "./resourceItem.vue?vue&type=template&id=58539f2a&"
import script from "./resourceItem.vue?vue&type=script&lang=js&"
export * from "./resourceItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "resourceItem.vue"
export default component.exports